import firebase from 'firebase/app'
import React from 'react'
import { useForm, Controller } from 'react-hook-form'
import { CustomDialogContent } from '..'
import { Grid, TextField } from '@material-ui/core'
import { useDispatch } from 'react-redux'
import { openSnackbar } from '../../ducks/snackbar/actions'
import { IComment } from 'daily-dose-common'
import { firestore } from '../../firebase-init'

interface IEditCommentFormProps {
  commentRef?: firebase.firestore.CollectionReference<firebase.firestore.DocumentData>
  onUpdateComment: (comment: IComment) => void
  comment: IComment
  onCancelComment: () => void
}

type InputsForm = {
  newContent: string
}

const EditCommentForm = ({
  onUpdateComment,
  comment,
  onCancelComment,
}: IEditCommentFormProps) => {
  const dispatch = useDispatch()
  const { handleSubmit, errors, control } = useForm<InputsForm>()

  const onSubmit = async (data: InputsForm) => {
    const { newContent } = data

    const { circleId, doseId, id } = comment
    const commentRef = firestore.doc(
      `circles/${circleId}/doses/${doseId}/comments/${id}`
    )

    // TODO: Refactor
    try {
      await commentRef?.update({
        content: newContent,
        updatedAt: firebase.firestore.Timestamp.now(),
      })

      onUpdateComment({
        ...comment,
        content: newContent,
        updatedAt: firebase.firestore.Timestamp.now(),
      })
    } catch (error) {
      console.warn('Error updating comment', error)
      dispatch(
        openSnackbar('Opps. We could not update your comment. Try again', 'error')
      )
    }
  }

  // TODO: Refactor this. Create a custom Dialog component
  return (
    <CustomDialogContent
      title="Update comment"
      confirmText="Update"
      onCancel={onCancelComment}
      onSubmit={handleSubmit(onSubmit)}
    >
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="AddDose"
        style={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <Controller
              as={TextField}
              control={control}
              rules={{ required: true }}
              multiline
              defaultValue={comment.content}
              variant="outlined"
              margin="normal"
              fullWidth
              label="Comment"
              autoComplete="off"
              type="text"
              error={!!errors.newContent}
              helperText={!!errors.newContent && 'Your comment cannot be empty.'}
              name="newContent"
              placeholder="Comment"
            />
          </Grid>
        </Grid>
      </form>
    </CustomDialogContent>
  )
}

export default EditCommentForm
